import Typography from '@material-ui/core/Typography';
const News=()=>{
    return(
        <Typography variant="h3">News</Typography>
    );
}
export default News;